<template>
  <v-container
    id="organizations-view"
    fluid
    tag="section"
  >
    <cumulus-edit-dialog
      ref="editModules"
      v-model="dialogEditModules"
      icon="$edit"
      :title="$t('modules')"
      :loading="loading"
      @save="saveModules"
      @escape="closeDialogEditModules"
    >
      <template v-slot:editform>
        <edit-organization-modules
          :organization="editedItem"
        />
      </template>
    </cumulus-edit-dialog>

    <material-card
      icon="$organizations"
      icon-small
      color="accent"
      :title="page_title"
    >
      <v-card-title>
        <v-btn
          v-shortkey.once="['f2']"
          color="primary"
          :disabled="!editor"
          class="mb-2"
          @shortkey="newItem()"
          @click="newItem()"
        >
          {{ $t('new_item',{ item: $t('organization') }) }}
        </v-btn>
        <v-switch
          v-model="showInactive"
          class="ml-2"
          :label="$t('show_inactive')"
        />
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="$search"
          class="ml-auto"
          hide-details
          :label="$t('search_records')"
          single-line
        />
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
          :item-class="rowClasses"
        >
          <template v-slot:item.avatar="{item}">
            <v-img
              v-if="item.avatar"
              :src="'data:image/jpeg;base64,' + item.avatar.thumbnail"
              width="50"
              height="50"
            />
          </template>
          <template #item.actions="{item}">
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :color="action.color"
              :disabled="action.disable"
              :icon="action.iconCalc ? action.iconCalc(item) : action.icon"
              :tooltip="action.tooltip"
              :to="action.to ? action.to+item.id : ''"
              @click="action.func ? action.func(item) : ''"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync } from 'vuex-pathify'
  import EditOrganizationModules from '@/layouts/default/edit/OrganizationModules'
  import TooltipBtn from '@/components/TooltipBtn'

  export default {
    name: 'Organizations',
    components: { TooltipBtn, EditOrganizationModules },
    data () {
      return {
        items: [],
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        total: 0,
        timer: null,
        dialogEditModules: false,
        editedItem: {},
        showInactive: false,
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('organization/options'),
      search: sync('organization/search'),
      headers () {
        return [
          {
            align: 'start',
            value: 'avatar',
            sortable: false,
            width: 50,
          },
          {
            text: this.$t('fields.name'),
            sortable: true,
            value: 'name',
          },
          {
            text: this.$t('fields.address'),
            sortable: false,
            value: 'address_site',
          },
          {
            text: this.$t('actions'),
            value: 'actions',
            sortable: false,
            align: 'right',
            width: 180,
          },
        ]
      },
      actions () {
        return [
          /* {
            color: 'info',
            icon: '$info',
            tooltip: 'tooltip_info',
          }, */
          {
            color: 'edit',
            icon: '$edit',
            tooltip: 'tooltip_edit',
            disable: !this.editor,
            func: this.edit,
          },
          {
            color: 'edit',
            icon: '$modules',
            tooltip: 'tooltip_modules',
            disable: !this.editor,
            func: this.showDialogEditModules,
          },
          {
            color: 'edit',
            icon: '$permissions',
            tooltip: 'tooltip_permits',
            disable: !this.editor,
            to: '/organization/permits/',
          },
          {
            color: 'action',
            icon: '$subscriptions',
            tooltip: 'tooltip_subscriptions',
            disable: !this.editor,
            func: this.subscriptions,
          },
          {
            color: 'red',
            iconCalc: this.getEnabledIcon,
            tooltip: 'tooltip_activate',
            disable: !this.editor,
            func: this.saveStatus,
          },
        ]
      },
      page_title () { return this.$t('organizations') },
      editor () { return this.profile.can['organization-edit'] },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.options.page = 1
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
      showInactive: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      // this.load()
    },
    methods: {
      getList: call('organization/search'),
      setModules: call('organization/setModules'),
      setStatus: call('organization/setStatus'),
      async load () {
        try {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options
          await this.getList({
            page: page,
            per_page: itemsPerPage,
            sort: {
              field: sortBy,
              order: sortDesc,
            },
            search: this.search,
            show_inactive: this.showInactive,
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
          })
        } catch (e) {
        }
      },
      newItem (item) {
        this.$router.push('/organization/new').catch(() => {})
      },
      edit (item) {
        this.$router.push(`/organization/edit/${item.id}`).catch(() => {})
      },

      showDialogEditModules (item) {
        this.editedItem = Object.assign({}, item)
        this.dialogEditModules = true
      },
      closeDialogEditModules () {
        this.dialogEditModules = false
        this.load()
      },
      async saveModules () {
        console.log(this.editedItem)
        this.setModules(
          this.editedItem,
        ).then(response => {
          this.editedItem = response
          this.closeDialogEditModules()
        }).catch(e => {
          this.$refs.editModules.setErrors(e)
        })
      },

      subscriptions (item) {
        this.$router.push(`/organization/${item.id}/subscriptions`).catch(() => {})
      },
      saveStatus (item) {
        this.setStatus(item)
        this.load()
      },
      rowClasses (item) {
        if (!item.enable) {
          console.log(item.enable)
          return 'red lighten-5'
        }
      },
      getEnabledIcon (item) {
        return item.enable ? 'mdi-close' : 'mdi-check'
      },
    },
  }
</script>

<style lang="sass">
.orange
  background-color: #ffdede
</style>
